'use strict';

require('../../company/CompanyService.js');
require('../../company/publications/CompanyPublicationActivity.js');
require('../../company/publications/CompanyPublicationActivityDirective.js');
require('../../company/publications/CompanyPublicationKeypassService.js');

function CompanyGuestKeypassesDetailCtrl(
  $scope,
  publication,
  translations,
  $stateParams,
  $state,
  CompanyService,
  CompanyPublicationService,
  CompanyPublicationKeypassService,
  $sce,
  config,
  activityService
) {
  $scope.companyId = $stateParams.companyId;
  $scope.publication = publication;
  $scope.translations = translations;
  $scope.activityService = activityService;

  $scope.tabs = [
    {
      'title': $sce.trustAsHtml(translations['publication.information']),
        'content': '',
        'template': 'partials/company-guest/keypasses/detail/latest.html',
        'icon': 'info-circle'
    }
  ];

  $scope.tabs.activeTab = 0;
  CompanyPublicationKeypassService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise.then(function(resp){
    $scope.keypass = resp;
  });
}

CompanyGuestKeypassesDetailCtrl.resolve = {
  publication: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
    return CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'publication.information'
    ]);
  }],
  activityService: ['$stateParams', 'CompanyPublicationActivity', function($stateParams, CompanyPublicationActivity) {
    return new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
  }]
};
module.exports = CompanyGuestKeypassesDetailCtrl;

angular.module('dokiv')
  .controller('CompanyGuestKeypassesDetailCtrl', [
  '$scope',
  'publication',
  'translations',
  '$stateParams',
  '$state',
  'CompanyService',
  'CompanyPublicationService',
  'CompanyPublicationKeypassService',
  '$sce',
  'config',
  'activityService',
  CompanyGuestKeypassesDetailCtrl
]);





//////////////////
// WEBPACK FOOTER
// ./scripts/company-guest/keypasses/CompanyGuestKeypassesDetailCtrl.js
// module id = 293
// module chunks = 0